import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { TUTORING_LEAD_SOURCES } from "@seneca/tutoring-service-consts";

import { OneToOneTutoringSourceParamKey } from "features/parents/routes/parent/routes/tutoring-page/links";

const { UNSET } = TUTORING_LEAD_SOURCES;

export default function useGetOneToOneTutoringSourceParam() {
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const source = searchParams.get(OneToOneTutoringSourceParamKey);

  const isValidSource = Object.values(TUTORING_LEAD_SOURCES).includes(
    source as any
  );

  return isValidSource ? (source as TUTORING_LEAD_SOURCES) : UNSET;
}
